// extracted by mini-css-extract-plugin
export default {"container":"OutstreamVideoAd-module__container___xzymZ","center":"OutstreamVideoAd-module__center___dFkOH"};